import { Disclosure, Transition } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/outline';
import Balancer from 'react-wrap-balancer';

const faq = [
  {
    question: 'How much does Jove’s service cost?',
    answer:
      'Jove charges no integration or licence fees up-front and is free for all partners. Our product works as tech-enabled insurance broker, so we only earn our revenue when your candidates purchase insurances from us.',
  },
  {
    question: 'How long does it take to integrate with Jove?',
    answer:
      'Jove has already integrated with Deel and Bullhorn. If you use Deel, simply log into Jove portal, and click on "Connect with Deel" button in "Organisation", "Candidate" tab. See full guide <a target="_blank" href="https://jove.co/deelQ&A">here</a>. For any other integration, our in-house team does all lifting. We can add new integration with CRM systems within a few weeks.',
  },
  {
    question: 'How does Jove ensure total compliance?',
    answer:
      'Jove’s real-time validation tool checks your contractors’ insurance policy and expiry date to ensure sufficient cover at all times. That way, your agency is always compliant and protected.',
  },

  {
    question: 'Which recruitment system do you integrate with?',
    answer:
      'We are currently integrated with Deel and Bullhorn. This means as soon as you place contractors through Deel or Bullhorn, these contractors will be automatically imported into Jove to start the validation process. If you use or prefer another CRM or candidate onboarding system, let us know and we can add that into our roadmap.',
  },
];

export const FAQSection = () => {
  return (
    <div className="bg-white py-8 lg:py-12">
      <div className="container mx-auto lg:pb-24">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8 ">
          <div className="px-4 lg:col-span-5 lg:px-0">
            <h3>Frequently asked questions</h3>
          </div>
          <div className="mt-10 lg:col-span-7 lg:mt-0">
            <div className="w-full px-4">
              <div className="mx-auto w-full space-y-4 rounded-2xl bg-white p-2">
                {faq.map((item, index) => (
                  <Disclosure
                    key={index}
                    as="div"
                    className="p rounded-lg bg-gray-100 py-4"
                  >
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full items-center justify-between px-4 text-left text-xl font-semibold">
                          <span>{item.question}</span>
                          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white ">
                            <ChevronUpIcon
                              className={`${
                                !open ? 'rotate-180 transform' : ''
                              } h-5 w-5`}
                            />
                          </div>
                        </Disclosure.Button>
                        <Transition
                          show={open}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                        >
                          <Disclosure.Panel
                            className="px-4 pt-4 pb-2 text-sm text-gray-500"
                            static
                          >
                            <Balancer>
                              <div
                                className="faq-answer text-base"
                                dangerouslySetInnerHTML={{
                                  __html: item.answer,
                                }}
                              />
                            </Balancer>
                          </Disclosure.Panel>
                        </Transition>
                      </>
                    )}
                  </Disclosure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
